export default "__VITE_ASSET__uJBo_mWV__"